import { useEffect, useRef, useState } from 'react';

export function useScrollAnimation(options = {}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setIsVisible(true);
          setHasAnimated(true);
        }
      },
      {
        threshold: options.threshold || 0.15,
        rootMargin: options.rootMargin || '0px 0px -50px 0px',
      }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [hasAnimated, options.threshold, options.rootMargin]);

  return { ref, isVisible };
}

export function useStaggeredAnimation(count, options = {}) {
  const ref = useRef(null);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const delays = Array.from({ length: count }, (_, i) => i);
          delays.forEach((i) => {
            setTimeout(() => {
              setVisibleItems((prev) => [...prev, i]);
            }, i * (options.staggerDelay || 120));
          });
          observer.disconnect();
        }
      },
      { threshold: options.threshold || 0.15 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [count, options.staggerDelay, options.threshold]);

  return { ref, visibleItems };
}
